module.exports = __webpack_public_path__ + "static/img/column_recommendation4_3.fed8fc39.png";